export const ROUTES = {
  REGISTER: '/lead/register',
  REGISTER_BOOKKEEPER: '/lead/register-bookkeeper',
  REGISTER_BOOKKEEPER_QUESTION: '/lead/register-bookkeeper-questions',
  REGISTER_QUESTION: '/lead/register-questions',
  REGISTER_QUESTION_LOOK_AROUND: '/lead/register-question-look-around',
  REGISTER_QUESTION_ACTIVITY: '/lead/register-question-activity',
} as const;
